/*
 * @Author: Teemo Ding
 * @Date: 2021-06-25 14:27:12
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-12 09:41:20
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/PackingSlip/PackingSlipInformation/index.tsx
 */
import React, { Fragment } from 'react';
import { Form, Divider } from 'antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import Configuration from '@/src/components/Configuration/Configuration';
import { InfoCircleOutlined } from '@ant-design/icons';
import Label from '../Components/Label';
import Row from '@/src/components/Layouts/Row/Row';
import SelectObjectAsValue from '@/src/components/SelectObjectAsValue';
import {
  PhoneNumber,
  AreaCodeInfo,
} from 'src/pages/CustomerDatabaseConfig/Components/CustomerInfoModal';
import { getAreaCodes } from 'src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import {
  Checkbox,
  Input,
  Radio,
  //Select,
  TextArea,
} from '@/src/components/Antd';
//import { Icon } from '@/src/tools/icon';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';

import css from '../css.module.less';
const PackingSlipInformation = ({
  storeData,
  states,
  // countries,
  // defaultAreaText,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    name: storeName = '',
    entityName = '',
    entityRegistrationNumber = '',
    country = {},
    email = '',
    addressLine = '',
    subdivision = {},
    postCode = '',
  } = storeData || {};
  // const areaCodesOptions = countries.map((item) => ({
  //   value: `+${item.areaCode}`,
  //   label: `${item.name} (+${item.areaCode})`,
  // }));

  const statesOptions = states.map((item) => ({
    uuid: item.uuid,
    name: item.name,
  }));
  const options = useSelector(getAreaCodes());

  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      title={getI18n('storeLogistics.packingSlip.packingSlipInformation')}
      subtitle={getI18n(
        'storeLogistics.packingSlip.packingSlipInformationSubTitle',
      )}>
      <Form.Item name='informationCustomized'>
        <Radio
          className={css.informationCustomized}
          radioList={[
            {
              label: getI18n('storeLogistics.packingSlip.usestoreinformation'),
              value: false,
            },
            {
              label: getI18n(
                'storeLogistics.packingSlip.customisesaleschannelinformation',
              ),
              value: true,
            },
          ]}></Radio>
      </Form.Item>
      <Divider></Divider>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.informationCustomized !==
          currentValues.informationCustomized
        }>
        {({ getFieldValue }) => (
          <Fragment>
            <Form.Item
              name='slipTitle'
              labelCol={{
                span: 24,
              }}
              rules={[
                {
                  required: true,
                  message: replaceI18nVariables(
                    getI18n('general.fieldisrequired'),
                    getI18n('storeLogistics.packingSlip.invoiceTitle'),
                  ),
                },
              ]}
              label={
                <Label
                  title={`${getI18n(
                    'storeLogistics.packingSlip.packingSlipTitle',
                  )}*`}
                  bottomTitle={getI18n(
                    'storeLogistics.packingSlip.packingSlipTitle',
                  )}
                />
              }>
              <Input size='large' className={css.input} />
            </Form.Item>
          </Fragment>
        )}
      </Form.Item>
      <Form.Item
        className={css.checkboxBoxContain}
        shouldUpdate
        // ={(prevValues, currentValues) =>
        //   prevValues.informationCustomized !==
        //     currentValues.informationCustomized ||
        //   prevValues.phoneEnabledCustomized !==
        //     currentValues.phoneEnabledCustomized ||
        //   prevValues.emailEnabledCustomized !==
        //     currentValues.emailEnabledCustomized ||
        //   prevValues.addressEnabledCustomized !=
        //     currentValues.addressEnabledCustomized
        // }
      >
        {({ getFieldValue }) => {
          const areaCodeInfo = getFieldValue('areaCodeInfo');
          const areaCodeInText =
            get(
              options.find((i) => i.uuid === get(areaCodeInfo, 'uuid')),
              'areaCode',
            ) || '';
          const phone = getFieldValue('phone');
          return (
            <Fragment>
              <div className={css.flexContain}>
                {/* Store Name */}
                <Form.Item
                  noStyle
                  name={
                    getFieldValue('informationCustomized')
                      ? 'storeNameEnabledCustomized'
                      : 'storeNameEnabled'
                  }
                  valuePropName='checked'>
                  <Checkbox className={css.checkboxBox}>
                    <span className={css.checkTitle}>
                      {getI18n('storeLogistics.packingSlip.storeName')}
                    </span>
                    <span>{storeName}</span>
                  </Checkbox>
                </Form.Item>
                {/* Entity Name */}
                <Form.Item
                  noStyle
                  name={
                    getFieldValue('informationCustomized')
                      ? 'entityNameEnabledCustomized'
                      : 'entityNameEnabled'
                  }
                  valuePropName='checked'>
                  <Checkbox className={css.checkboxBox}>
                    <span className={css.checkTitle}>
                      {getI18n('storeLogistics.packingSlip.entityName')}
                    </span>
                    <span>{entityName}</span>
                  </Checkbox>
                </Form.Item>

                {/* Entity Registration Number */}
                <Form.Item
                  noStyle
                  name={
                    getFieldValue('informationCustomized')
                      ? 'entityRegistrationNumberEnabledCustomized'
                      : 'entityRegistrationNumberEnabled'
                  }
                  valuePropName='checked'>
                  <Checkbox className={css.checkboxBox}>
                    <span className={css.checkTitle}>
                      {getI18n(
                        'storeLogistics.packingSlip.entityRegistrationNumber',
                      )}
                    </span>
                    <span>{entityRegistrationNumber}</span>
                  </Checkbox>
                </Form.Item>
                {/* Payment Information */}
                <Form.Item
                  noStyle
                  name={
                    getFieldValue('informationCustomized')
                      ? 'paymentEnabledCustomized'
                      : 'paymentEnabled'
                  }
                  valuePropName='checked'>
                  <Checkbox className={css.checkboxBox}>
                    <span className={css.checkTitle}>
                      {getI18n('storeLogistics.packingSlip.paymentInformation')}
                    </span>
                    <span>
                      {getI18n(
                        'storeLogistics.packingSlip.paymentInformationDescription',
                      )}
                    </span>
                  </Checkbox>
                </Form.Item>
              </div>
              <div className={css.flexContain}>
                {/* phone */}
                <Fragment>
                  {getFieldValue('informationCustomized') ? (
                    <div className={css.checkboxAndInput}>
                      <Form.Item
                        noStyle
                        name='phoneEnabledCustomized'
                        valuePropName='checked'>
                        <Checkbox className={css.checkboxBox}>
                          <span className={css.checkTitle}>
                            {getI18n('storeLogistics.packingSlip.phone')}
                          </span>
                        </Checkbox>
                      </Form.Item>
                      {getFieldValue('phoneEnabledCustomized') ? (
                        <div className={css.checkboxInput}>
                          <Form.Item
                            name='areaCodeInfo'
                            className={css.combinationSelect}>
                            <AreaCodeInfo />
                            {/* <Select
                            size='large'
                            suffixIcon={
                              <Icon type='icondown' className={css.icon} />
                            }
                            getPopupContainer={(trigger) => trigger}
                            optionsList={areaCodesOptions}
                            optionLabelProp='label'
                            dropdownClassName={css.dropdown}
                            dropdownRender={(menu) => (
                              <div>
                                {defaultAreaText && (
                                  <div className={css.defaultAreaCode}>
                                    {defaultAreaText}
                                  </div>
                                )}
                                {defaultAreaText && (
                                  <Divider
                                    className={css.divider}
                                    style={{ margin: '4px 0' }}
                                  />
                                )}
                                {menu}
                              </div>
                            )}
                          /> */}
                          </Form.Item>
                          <Form.Item name='phone' style={{ flex: 1 }}>
                            {/* <Input size='large' /> */}
                            <PhoneNumber className={css.phoneInput} />
                          </Form.Item>
                        </div>
                      ) : (
                        <span className={css.subText}>
                          +{areaCodeInText} {phone}
                        </span>
                      )}
                      {/* </Form.Item> */}
                    </div>
                  ) : (
                    <Form.Item
                      noStyle
                      name='phoneEnabled'
                      valuePropName='checked'>
                      <Checkbox className={css.checkboxBox}>
                        <span className={css.checkTitle}>Phone</span>
                        <span>
                          +{areaCodeInText} {phone}
                        </span>
                      </Checkbox>
                    </Form.Item>
                  )}
                </Fragment>
                {/* Email */}
                <Fragment>
                  {getFieldValue('informationCustomized') ? (
                    <div className={css.checkboxAndInput}>
                      <Form.Item
                        noStyle
                        name='emailEnabledCustomized'
                        valuePropName='checked'>
                        <Checkbox className={css.checkboxBox}>
                          <span className={css.checkTitle}>
                            {getI18n('storeLogistics.packingSlip.email')}
                          </span>
                        </Checkbox>
                      </Form.Item>
                      {getFieldValue('emailEnabledCustomized') ? (
                        <Form.Item
                          className={css.checkboxInput}
                          name='email'
                          rules={[
                            {
                              type: 'email',
                              message: getI18n('general.invalidformat'),
                            },
                          ]}>
                          <Input size='large' />
                        </Form.Item>
                      ) : (
                        <span className={css.subText}>{email || '-'}</span>
                      )}
                    </div>
                  ) : (
                    <Form.Item
                      noStyle
                      name='emailEnabled'
                      valuePropName='checked'>
                      <Checkbox className={css.checkboxBox}>
                        <span className={css.checkTitle}>
                          {getI18n('storeLogistics.packingSlip.email')}
                        </span>
                        <span>{email || '-'}</span>
                      </Checkbox>
                    </Form.Item>
                  )}
                </Fragment>
                {/* Address */}
                <Fragment>
                  {getFieldValue('informationCustomized') ? (
                    <div className={css.checkboxAndInput}>
                      <Form.Item
                        noStyle
                        name='addressEnabledCustomized'
                        valuePropName='checked'>
                        <Checkbox className={css.checkboxBox}>
                          <span className={css.checkTitle}>
                            {getI18n('storeLogistics.packingSlip.address')}
                          </span>
                        </Checkbox>
                      </Form.Item>
                      {getFieldValue('addressEnabledCustomized') ? (
                        <Fragment>
                          <Row
                            containerClassName={css.addressLine}
                            elements={[
                              {
                                child: (
                                  <Form.Item
                                    name='addressLine'
                                    className={css.addressLineItem}>
                                    <TextArea
                                      size='large'
                                      autoSize={{ minRows: 1, maxRows: 2 }}
                                    />
                                  </Form.Item>
                                ),
                              },
                            ]}
                          />
                          <Row
                            containerClassName={css.addressLine}
                            elements={[
                              {
                                child: (
                                  <Form.Item
                                    label={
                                      <Label
                                        title={getI18n(
                                          'storeLogistics.packingSlip.countryRegion',
                                        )}
                                      />
                                    }
                                    labelCol={{
                                      span: 24,
                                    }}>
                                    <div>{(country || {}).name}</div>
                                  </Form.Item>
                                ),
                              },
                              {
                                child: (
                                  <Form.Item
                                    name='subdivision'
                                    label={
                                      <Label
                                        title={`${getI18n(
                                          'storeLogistics.packingSlip.stateProvinceDistrict',
                                        )}* `}
                                      />
                                    }
                                    rules={[
                                      {
                                        required: true,
                                        message: replaceI18nVariables(
                                          getI18n('general.fieldisrequired'),
                                          getI18n(
                                            'storeLogistics.packingSlip.stateProvinceDistrict',
                                          ),
                                        ),
                                      },
                                    ]}
                                    labelCol={{
                                      span: 24,
                                    }}>
                                    <SelectObjectAsValue
                                      objectAsValue
                                      size='large'
                                      getPopupContainer={(trigger: any) =>
                                        trigger
                                      }
                                      valueKey='uuid'
                                      labelKey='name'
                                      options={statesOptions}
                                    />
                                  </Form.Item>
                                ),
                              },
                              {
                                child: (
                                  <Form.Item
                                    name='postCode'
                                    label={
                                      <Label
                                        title={getI18n(
                                          'storeLogistics.packingSlip.postcodeZip',
                                        )}
                                      />
                                    }
                                    labelCol={{
                                      span: 24,
                                    }}>
                                    <Input size='large' />
                                  </Form.Item>
                                ),
                              },
                            ]}
                          />
                        </Fragment>
                      ) : (
                        <span className={css.subText}>
                          {addressLine} <br />
                          {country.name || {}} {(subdivision || {}).name}{' '}
                          {postCode}
                        </span>
                      )}
                    </div>
                  ) : (
                    <Form.Item
                      noStyle
                      name='addressEnabled'
                      valuePropName='checked'>
                      <Checkbox className={css.checkboxBox}>
                        <span className={css.checkTitle}>
                          {' '}
                          {getI18n('storeLogistics.packingSlip.address')}
                        </span>
                        <span>
                          {addressLine} <br />
                          {country.name || {}} {(subdivision || {}).name}{' '}
                          {postCode}
                        </span>
                      </Checkbox>
                    </Form.Item>
                  )}
                </Fragment>
              </div>
            </Fragment>
          );
        }}
      </Form.Item>
      <Configuration
        configStart={getI18n('storeLogistics.packingSlip.pleasegotoSettings')}
        configLink={getI18n('storeLogistics.packingSlip.storeDetails')}
        linkTo='/settings/storeDetails'
        configEnd={getI18n('storeLogistics.packingSlip.editcompanyinformation')}
      />
      <div>
        <InfoCircleOutlined />{' '}
        {getI18n('storeLogistics.packingSlip.guideConfigTips')}
      </div>
    </SectionWrapper>
  );
};
export default PackingSlipInformation;
